export enum AddonCost {
  PAID_BY_PRODUCT_TEAM = 'Requires additional cost (paid for by Product/Platform team)',
  PAID_BY_REQUESTOR = 'Requires additional cost (paid for by Requestor\'s organization)',
  NO_ADDITIONAL_COST = 'No additional cost',
}
